// import React, { useEffect, useState } from "react";
// import AppHeader from "./Header";
// import {
//   AppShell,
//   Header,
//   Navbar,
//   ActionIcon,
//   ScrollArea,
// } from "@mantine/core";
// import {
//   IconArrowBadgeRight,
//   IconBadge,
//   IconBell,
//   IconCircleCheck,
//   IconFileReport,
//   IconFileTypePdf,
//   IconHome,
//   IconLayoutSidebarLeftCollapse,
//   IconLayoutSidebarRightCollapse,
//   IconLock,
//   IconPlus,
//   IconProgress,
//   IconReport,
//   IconReportAnalytics,
//   IconTimeline,
//   IconUsers,
// } from "@tabler/icons-react";
// import { IconFile } from "@tabler/icons-react";
// import { getUnseenNotificationsCount } from "../apis/notificationapi";
// import { getCookiesSession } from "../cookiesSession";

// const SideNav = ({ appContent }) => {
//   const cookieData = JSON.parse(getCookiesSession("LawSignaUserDataMaster"));
//   const userData = cookieData.user;
//   const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
//   // const userData = JSON.parse(localStorage.getItem("userData"));
//   const [unseen, setUnseen] = useState(null);

//   const filter = {
//     role: userData.loginAs.name, // Use optional chaining to prevent errors if `userData` is null or undefined
//     department: userData?.department,
//   };

//   useEffect(() => {
//     const getUnseenCount = async () => {
//       try {
//         const response = await getUnseenNotificationsCount({ filter });
//         setUnseen(response?.count || 0);
//       } catch (error) {
//         console.error("Error fetching unseen notifications count:", error);
//       }
//     };

//     if (filter.role && filter.department) {
//       // Ensure filter fields are valid before making the request
//       getUnseenCount();
//     }
//   }, [filter.role, filter.department]);

//   return (
//     <>
//       <AppShell
//         navbar={
//           <Navbar
//             style={{ backgroundColor: "#EEF2F3" }}
//             width={{ base: sidebarCollapsed ? 50 : 240 }}
//             height="calc(100vh - 65px)"
//           >
//             <Navbar.Section grow component={ScrollArea}>
//               <div className="flex flex-col">
//                 <div className="flex justify-end mt-2">
//                   <ActionIcon
//                     color="blue"
//                     onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
//                     style={{ cursor: "pointer", marginRight: "9%" }}
//                   >
//                     {sidebarCollapsed ? (
//                       <IconLayoutSidebarRightCollapse
//                         color="#46bde1"
//                         size={25}
//                       />
//                     ) : (
//                       <IconLayoutSidebarLeftCollapse
//                         color="#46bde1"
//                         size={25}
//                       />
//                     )}
//                   </ActionIcon>
//                 </div>
//                 {!sidebarCollapsed && (
//                   <div className="flex flex-col p-3">
//                     <div className="space-y-3">
//                       <div className="flex-1">
//                         <ul className=" pb-4 space-y-3 text-sm">
//                           {userData.loginAs.name.name !== "Auditor" && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/dashboard"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconHome
//                                   style={{ padding: "2px" }}
//                                   color="#46bde1"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   dashboard
//                                 </span>
//                               </a>
//                             </li>
//                           )}
//                           {(userData.loginAs.name === "DeptUser" ||
//                             userData.loginAs.name === "DeptAdmin" ||
//                             userData.loginAs.name === "Admin" ||
//                             userData.loginAs.name === "Auditor") && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/notifications"
//                                 className="flex justify-between"
//                               >
//                                 <div className="flex  p-2 space-x-4 rounded-md">
//                                   <IconBell
//                                     style={{ padding: "2px" }}
//                                     color="#46bde1"
//                                     size={25}
//                                   />
//                                   <span style={{ fontWeight: "500" }}>
//                                     notifications
//                                   </span>
//                                 </div>
//                                 <div className="flex justify-center mt-2">
//                                   <span
//                                     className="rounded  text-center mr-2"
//                                     style={{
//                                       borderRadius: "50%",
//                                       textAlign: "center",
//                                       fontWeight: "500",
//                                       backgroundColor: "#46bde1",
//                                       width: "22px",
//                                       height: "22px",
//                                       lineHeight: "20px",
//                                       color: "white",
//                                       padding: "1px",
//                                     }}
//                                   >
//                                     {unseen !== null && unseen}
//                                   </span>
//                                 </div>
//                               </a>
//                             </li>
//                           )}
//                           {(userData.loginAs.name === "Admin" ||
//                             userData.loginAs.name === "Editor" ||
//                             userData.loginAs.name === "Editor") && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/new"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconPlus
//                                   style={{ padding: "2px" }}
//                                   color="#46bde1"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   new obligation
//                                 </span>
//                               </a>
//                             </li>
//                           )}
//                           {userData.loginAs.name === "DeptAdmin" && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/acceptobligation"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconCircleCheck
//                                   style={{ padding: "2px" }}
//                                   color="#46bde1"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   accept obligations
//                                 </span>
//                               </a>
//                             </li>
//                           )}
//                           {(userData.loginAs.name === "DeptUser" ||
//                             userData.loginAs.name === "DeptAdmin") && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/assigned"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconReport
//                                   style={{ padding: "2px" }}
//                                   color="#46bde1"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   my obligations
//                                 </span>
//                               </a>
//                             </li>
//                           )}
//                           {(userData.loginAs.name === "DeptUser" ||
//                             userData.loginAs.name === "DeptAdmin") && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/actioned"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconProgress
//                                   style={{ padding: "2px" }}
//                                   color="#46bde1"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   actioned obligations
//                                 </span>
//                               </a>
//                             </li>
//                           )}
//                           {(userData.loginAs.name === "Editor" ||
//                             userData.loginAs.name === "DeptAdmin" ||
//                             userData.loginAs.name === "CXO" ||
//                             userData.loginAs.name === "Editor" ||
//                             userData.loginAs.name === "CEO" ||
//                             userData.loginAs.name === "COO" ||
//                             userData.loginAs.name === "Admin" ||
//                             userData.loginAs.name === "Auditor") && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/obligationtracker"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconReportAnalytics
//                                   style={{ padding: "2px" }}
//                                   color="#46bde1"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   obligations monitor
//                                 </span>
//                               </a>
//                             </li>
//                           )}
//                           {(userData.loginAs.name === "Editor" ||
//                             userData.loginAs.name === "Admin" ||
//                             userData.loginAs.name === "Editor") && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/docslocker"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconLock
//                                   style={{ padding: "2px" }}
//                                   color="#46bde1"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   agreements locker
//                                 </span>
//                               </a>
//                             </li>
//                           )}
//                           {/* <li className="rounded-sm">
//                             <a
//                               href="/documents"
//                               className="flex items-center p-2 space-x-4 rounded-md"
//                             >
//                               <IconFile
//                                 style={{ padding: "2px" }}
//                                 color="#46bde1"
//                                 size={25}
//                               />
//                               <span style={{ fontWeight: "500" }}>
//                                 documents
//                               </span>
//                             </a>
//                           </li> */}
//                           {/* {(userData.loginAs.name === "Admin" ||
//                             userData.loginAs.name === "DeptAdmin") && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/team"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconUsers
//                                   style={{ padding: "2px" }}
//                                   color="#46bde1"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   team manager
//                                 </span>
//                               </a>
//                             </li>
//                           )} */}
//                         </ul>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </Navbar.Section>
//           </Navbar>
//         }
//         header={
//           <Header height={65} style={{ background: "#FFFFFF" }}>
//             <AppHeader />
//           </Header>
//         }
//       >
//         <div
//           style={{
//             backgroundColor: "#FFFFFF",
//             minHeight: "calc(100vh - 100px)",
//           }}
//         >
//           {appContent}
//         </div>
//       </AppShell>
//     </>
//   );
// };

// export default SideNav;

// // 21
// {
//   /* <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
//     <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 17V1m0 0L1 4m3-3 3 3m4-3h6l-6 6h6m-7 10 3.5-7 3.5 7m-6.125-2H16"/>
// </svg> */
// }

// // 31
// // <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 17 14">
// //     <path d="M16 2H1a1 1 0 0 1 0-2h15a1 1 0 1 1 0 2Zm0 6H1a1 1 0 0 1 0-2h15a1 1 0 1 1 0 2Zm0 6H1a1 1 0 0 1 0-2h15a1 1 0 0 1 0 2Z"/>
// // </svg>

import React, { useEffect, useState } from "react";
import AppHeader from "./Header";
import { AppShell, Header, Navbar, ActionIcon, ScrollArea } from "@mantine/core";
import {
  IconHome,
  IconBell,
  IconPlus,
  IconCircleCheck,
  IconReport,
  IconProgress,
  IconReportAnalytics,
  IconLock,
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarRightCollapse,
} from "@tabler/icons-react";
import { getUnseenNotificationsCount } from "../apis/notificationapi";
import { getCookiesSession } from "../cookiesSession";
import { LinksGroup } from "../pages/NavbarLinkGroup"; 
import "./sidebar.css";
import {MyBagIcon, DocLockerIcon, NotificationIcon, PlusIcon, TemplatesIcon, HomeIcon, TickIcon, ActionedIcon } from "../../src/icons/new-icons/icon";

const SideNav = ({ appContent }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [unseen, setUnseen] = useState(0);

  const cookieData = JSON.parse(getCookiesSession("LawSignaUserDataMaster") || "{}");
  const userData = cookieData?.user || {};
  const roleRaw = userData?.loginAs?.name || ""; // e.g., "Dept-User"
  const role = roleRaw.replace("-", "").trim(); // "DeptUser"
  const dept = userData?.department;

  useEffect(() => {
    const getUnseenCount = async () => {
      try {
        const response = await getUnseenNotificationsCount({ 
          filter: { role, department: dept } 
        });
        setUnseen(response?.count || 0);
      } catch (error) {
        console.error("Error fetching unseen notifications count:", error);
      }
    };

    if (role && dept) getUnseenCount();
  }, [role, dept]);

  // Define Menu Items based on your existing logic
  const menuData = [
    // MENU SECTION
    {
      label: "Overview",
      icon: HomeIcon,
      link: "/dashboard",
      initiallyOpened: true,
      section: "MENU",
      hidden: role?.name === "Auditor",
    },
    {
      label: "Alerts",
      icon: NotificationIcon,
      link: "/notifications",
      section: "MENU",
      hasNumber: unseen > 99 ? "99+" : unseen,
      hidden: !["DeptUser", "DeptAdmin", "Admin", "Auditor"].includes(role),
    },
    {
      label: "Create",
      icon: PlusIcon,
      link: "/new",
      section: "MENU",
      hidden: !["Admin", "Editor"].includes(role),
    },
    // OTHERS SECTION
    {
      label: "Accept Obligations",
      icon: ActionedIcon,
      link: "/acceptobligation",
      section: "OTHERS",
      hidden: role !== "DeptAdmin",
    },
    {
      label: "My Obligations",
      icon: TemplatesIcon,
      link: "/assigned",
      section: "OTHERS",
      hidden: !["DeptUser", "DeptAdmin"].includes(role),
    },
    {
      label: "Actioned Obligations",
      icon: TickIcon,
      link: "/actioned",
      section: "OTHERS",
      hidden: !["DeptUser", "DeptAdmin"].includes(role),
    },
    {
      label: "Obligations Register",
      icon: MyBagIcon,
      link: "/obligationtracker",
      section: "OTHERS",
      hidden: !["Editor", "DeptAdmin", "CXO", "CEO", "COO", "Admin", "Auditor"].includes(role),
    },
    {
      label: "Contracts List",
      icon: DocLockerIcon,
      link: "/docslocker",
      section: "OTHERS",
      hidden: !["Editor", "Admin"].includes(role),
    },
  ].filter(item => !item.hidden);

  const menuItems = menuData.filter(i => i.section === "MENU");
  const otherItems = menuData.filter(i => i.section === "OTHERS");

  return (
    <AppShell
      navbar={
        <Navbar
          className="sidebar-container"
          width={{ base: sidebarCollapsed ? 60 : 250 }}
          height="calc(100vh - 65px)"
          style={{ backgroundColor: "#EEF2F3", transition: "width 0.3s ease" }}
        >
          <Navbar.Section grow component={ScrollArea} className="pt-4">
            <div className="flex flex-col">
              {/* Toggle Button */}
              <span className="flex justify-end pr-3">
                <ActionIcon 
                  onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                  variant="transparent"
                >
                  {sidebarCollapsed ? (
                    <IconLayoutSidebarRightCollapse color="#649fb1" size={22} />
                  ) : (
                    <IconLayoutSidebarLeftCollapse color="#649fb1" size={22} />
                  )}
                </ActionIcon>
              </span>

              {!sidebarCollapsed && (
                <div className="animate-fade-in" style={{marginTop:"-35px"}}>
                  <div className="sidebar-heading">MENU</div>
                  {menuItems.map((item) => (
                    <LinksGroup {...item} key={item.label} />
                  ))}

                  {otherItems.length > 0 && (
                    <>
                      <div className="sidebar-heading mt-4">OTHERS</div>
                      {otherItems.map((item) => (
                        <LinksGroup {...item} key={item.label} />
                      ))}
                    </>
                  )}
                </div>
              )}
            </div>
          </Navbar.Section>
        </Navbar>
      }
      header={
        <Header height={65} style={{ background: "#FFFFFF", borderBottom: "1px solid #eaeaea" }}>
          <AppHeader />
        </Header>
      }
    >
      <div style={{ backgroundColor: "#FFFFFF", minHeight: "calc(100vh - 100px)"}}>
        {appContent}
      </div>
    </AppShell>
  );
};

export default SideNav;